import { type FormEvent, useState } from 'react';
import './enter-approver-parent-information-form.scss';
import { useDataAttributes } from '@data-attributes/use-data-attributes';
import { StandardButton } from '@eika/button';
import { useAccountApplicationActions } from '@hooks/context/use-account-application-context';
import { useLinks } from '@hooks/use-links';
import { useTranslation } from '@translations';
import { normalizePhoneNumber, validPhoneNumber } from '@utils/phone-validate-utils';
import { useNavigate } from 'react-router-dom';
import { ApproverParentPhoneInput } from './approver-parent-phone-input';

export const EnterApproverParentInformationForm = () => {
    const { enterApproverParentInformation, next } = useTranslation();
    const { setNotifyApproverParentOnPhoneNumber } = useAccountApplicationActions();
    const { enterApproverParentInformationDataAttributes } = useDataAttributes();
    const navigate = useNavigate();
    const { applicantParentSummary } = useLinks();

    const [phoneInputValue, updatePhoneInputValue] = useState('');
    const [formError, setFormError] = useState<string | undefined>(undefined);

    const submit = () => {
        setFormError(undefined);
        setNotifyApproverParentOnPhoneNumber(normalizePhoneNumber(phoneInputValue));
        navigate(applicantParentSummary.url);
    };

    const handleSave = (e: FormEvent) => {
        e.preventDefault();

        if (!validPhoneNumber(phoneInputValue)) {
            setFormError(enterApproverParentInformation.phoneValidationError);
            return;
        }

        submit();
    };

    const handleInputChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
        updatePhoneInputValue(target.value);

        if (formError) {
            setFormError(undefined);
        }
    };

    return (
        <form className="enter-approver-parent-information__form" onSubmit={handleSave}>
            <ApproverParentPhoneInput value={phoneInputValue} onChange={handleInputChange} error={formError} />
            <StandardButton
                className="enter-approver-parent-information__form--submit"
                type="submit"
                {...enterApproverParentInformationDataAttributes.submitButton}
            >
                {next}
            </StandardButton>
        </form>
    );
};
